// Real Trustpilot reviews — sourced from trustpilot.com/review/pfpmaker.com (5-star only).
// US reviews are listed first. To add more, append entries at the end (or insert before the
// first non-US entry to keep US at the top). country follows ISO 3166-1 alpha-2.

export interface PricingReview {
  name: string;
  avatar: string;
  country: string;
  text: string;
}

export const PRICING_REVIEWS: PricingReview[] = [
  // ── United States ──────────────────────────────────────────────────────────
  {
    name: "Brian Marranzini", avatar: "BM", country: "US",
    text: "I was surprised with how good some of the photos came out — my wife wants me to dress better and change my hair style based on a couple of them. There were a few misses but for $15 I got at least 10 usable updated headshots for work and some laughs.",
  },
  {
    name: "Kevin Bello", avatar: "KB", country: "US",
    text: "The user experience was simple to navigate. With 120 images made available, the likelihood of ending up with a handful that are very close to accurate is high. Value was very good for the amount charged. Customer service was fantastic — revisions turned around in less than 24 hours.",
  },
  {
    name: "MV", avatar: "MV", country: "US",
    text: "This company truly exceeded my expectations. After trying a few others, I can confidently say that PFPMaker has delivered the best results I have ever seen. The edits were done with remarkable precision and their customer service excelled. PFPMaker is the best in the business.",
  },
  {
    name: "D. Frank", avatar: "DF", country: "US",
    text: "Fantastic website, highly recommend.",
  },
  {
    name: "Stephanie Torres", avatar: "ST", country: "US",
    text: "Easy to use and so many different options to choose from. You can choose different background colors and reset for even more options.",
  },
  {
    name: "Edwin Salinas", avatar: "ES", country: "US",
    text: "Thank you for making this so easy! I tried several other sites and nothing was as easy as this!",
  },
  {
    name: "Leo Guerra", avatar: "LG", country: "US",
    text: "Efficient, easy and professional-looking PFP!",
  },
  {
    name: "Luba LFamily", avatar: "LL", country: "US",
    text: "Extremely cool and fun! Give it a try!",
  },
  {
    name: "Don Tilley", avatar: "DT", country: "US",
    text: "This was so easy and really cool. Way better than photos I took myself.",
  },
  {
    name: "John O.", avatar: "JO", country: "US",
    text: "Just got turned on to this tool. I'm blown away by how quick and simple this is to use. The number of variations is also very impressive.",
  },
  {
    name: "Rhonda Buchanan", avatar: "RB", country: "US",
    text: "Fantastic tool — it has helped me to create many creative profiles. Easy and straightforward. I love this tool.",
  },

  // ── International ──────────────────────────────────────────────────────────
  {
    name: "Vicwac", avatar: "VC", country: "ES",
    text: "From 80 pictures I picked the 15 best — they ALL look like me. My mother wasn't able to tell the difference. I followed their guide exactly and my results were honestly much better than I expected. This is a truly amazing tool. I didn't realise the power of AI was already this advanced.",
  },
  {
    name: "Dave Bakker", avatar: "DB", country: "NL",
    text: "It's genuinely challenging for me to look relaxed and good in photos. The money spent was incredibly well-invested. Most photos (~80%) turn out surprisingly well and are perfect for LinkedIn.",
  },
  {
    name: "D Tsai", avatar: "DC", country: "CA",
    text: "Easy to use with clear instructions — better quality photos in means better quality photos produced, lighting is important! My second package came out much better once my wife took the shots on the rear camera. I look forward to what's coming in future versions.",
  },
  {
    name: "Hey Jude", avatar: "HJ", country: "CA",
    text: "I've already recommended this to my online class. We were working on professional portfolios and I loved not having to leave the room to get headshots for the project.",
  },
  {
    name: "Victor W.", avatar: "VW", country: "CA",
    text: "Great SaaS to create amazing, gorgeous, and great-looking profile pics in minutes, if not seconds!",
  },
  {
    name: "Patrick Collins", avatar: "PC", country: "LT",
    text: "Amazing customer support when trying to get the right pictures. Quality of profile pictures is best on the market.",
  },
  {
    name: "Jesy Ramanandray", avatar: "JR", country: "FR",
    text: "Super practical and fast. A photo of me in my room was edited as if it wasn't in my room at all. I've been using it for my LinkedIn profile picture ever since.",
  },
  {
    name: "David Karasek", avatar: "DK", country: "CH",
    text: "It's super fast and easy to use. My LinkedIn profile looks a lot more professional now. Thank you!!",
  },
  {
    name: "Sweta Singh", avatar: "SS", country: "IN",
    text: "I never looked better in professional pics! Much cheaper than going to a studio.",
  },
  {
    name: "Sandeep Ghag", avatar: "SG", country: "IN",
    text: "90% of the job is amazing. 10% can be ignored.",
  },
  {
    name: "Mysterious Uniworld", avatar: "MU", country: "IN",
    text: "The interface is sleek and intuitive with a wide range of customisation options. No lags or delays at all. The final PFPs were high quality and perfectly suited my needs. Highly recommend to anyone looking for a seamless platform for eye-catching profile pictures.",
  },
  {
    name: "Sahil Pandey", avatar: "SP", country: "IN",
    text: "I stumbled upon pfpmaker.com and I'm absolutely impressed! An incredible service that surpassed my expectations in every way — speed, quality, and customisation options.",
  },
  {
    name: "Shailendra Maurya", avatar: "SM", country: "IN",
    text: "Profile Pic Maker is a great choice for anyone looking to create eye-catching profile pictures quickly. It created so many pictures with different backgrounds in seconds. Loved it!",
  },
  {
    name: "Michael Lanre", avatar: "ML", country: "NG",
    text: "I wanted to keep the same photo but with different backgrounds for a professional look. PFPMaker has now afforded me exactly that. Thank you.",
  },
  {
    name: "Regina B. Blankson", avatar: "RG", country: "NG",
    text: "The range of options was terrific, and I liked how it catered to varied profile perceptions. Thank you PFP — no more boring headshot pics.",
  },
  {
    name: "Maggie", avatar: "MG", country: "CU",
    text: "This worked so fast and so well I'm still shocked. It didn't edit my face or make me unrecognisable like other AIs — instead it gave me a nice background with colours that complement my features, and several options to choose from. I'll be using these for my CV.",
  },
  {
    name: "Riaz Shah", avatar: "RS", country: "MY",
    text: "I super love PFP Maker! My go-to site for professional icons. AI is definitely at its hallmark here for LinkedIn or any business shot — recommended for anyone needing great profile pics.",
  },
  {
    name: "Noname", avatar: "NN", country: "DE",
    text: "I have been using PFPMaker for over a year, and I am every time happy with the results.",
  },
  {
    name: "Marie-Clare Byard", avatar: "MB", country: "IE",
    text: "Brilliant app, totally recommend it.",
  },
  {
    name: "Austumas Papartis", avatar: "AP", country: "GB",
    text: "Very easy, fast and intuitive.",
  },
  {
    name: "Casey Ricketts", avatar: "CR", country: "QA",
    text: "Super easy, lots of good options, great customisability. It's free. Can't ask for more.",
  },
  {
    name: "Sohail Anwar Jan", avatar: "SJ", country: "PK",
    text: "I have never experienced such a fast, easy-to-use, and genuinely useful tool like PFPmaker.com.",
  },
  {
    name: "Abdul Mahad", avatar: "AM", country: "PK",
    text: "Best PFP maker online. I have been through many other software but this is by far the best one. Well done Team PFPMaker.",
  },
];
